import { Injectable } from '@angular/core';
import { ApiService } from './api-service/api.service';

@Injectable({
    providedIn: 'root',
})
export class AccessibilitySourceCodeExcludeRepoService {

    constructor (
        private apiService: ApiService,
    ) { }

    get (excludeId: string | number, params?: any, headers?: any): Promise<any> {
        params = params || {};
        return this.apiService.get('accessibility/source_code_excludes/' + excludeId, params, headers);
    }

    getAll (params?: any, headers?: any): Promise<any> {
        params = params || {};
        return this.apiService.get('accessibility/source_code_excludes', params, headers);
    }

    create (model: any, params?: any, headers?: any): Promise<any> {
        params = params || {};
        return this.apiService.post('accessibility/source_code_excludes', model, params, headers);
    }

    update (sourceExclude: any, model: any, params?: any, headers?: any): Promise<any> {
        return this.apiService.patch('accessibility/source_code_excludes/' + sourceExclude.id, model, params);
    }

    destroy (excludeId: string | number, params?: any, headers?: any): Promise<any> {
        params = params || {};
        return this.apiService.delete('accessibility/source_code_excludes/' + excludeId, params);
    }
}
